import { motion } from "framer-motion";
import { ON_AI } from "@/data/content";

const easeEditorial = [0.16, 1, 0.3, 1];

function RevealLine({ children, delay = 0, className = "" }) {
  return (
    <span className={`mask-line ${className}`}>
      <motion.span
        className="block will-change-transform"
        initial={{ y: "112%" }}
        whileInView={{ y: 0 }}
        viewport={{ once: true, margin: "-18%" }}
        transition={{ duration: 1.1, delay, ease: easeEditorial }}
      >
        {children}
      </motion.span>
    </span>
  );
}

export default function OnAI() {
  return (
    <section
      id="on-ai"
      data-testid="on-ai-section"
      className="relative bg-black text-white px-6 md:px-12 lg:px-16 py-24 md:py-36 lg:py-44"
    >
      {/* Chapter marker */}
      <div className="grid grid-cols-12 gap-6 mb-14 md:mb-24">
        <div className="col-span-6 md:col-span-3">
          <p
            data-testid="on-ai-chapter"
            className="text-[11px] uppercase tracking-[0.22em] text-neutral-400"
          >
            {ON_AI.chapter}
          </p>
        </div>
        <div className="col-span-6 md:col-span-3 md:col-start-10 md:text-right">
          <p className="text-[11px] uppercase tracking-[0.22em] text-neutral-400">
            {ON_AI.kicker}
          </p>
        </div>
      </div>

      {/* Opening statement */}
      <h2
        data-testid="on-ai-heading"
        className="font-serif font-light tracking-tight leading-[1.06] text-[clamp(1.9rem,5vw,4.25rem)] max-w-[26ch]"
      >
        <RevealLine>{ON_AI.lines[0]}</RevealLine>
        <RevealLine delay={0.12} className="text-neutral-500">
          {ON_AI.lines[1]}
        </RevealLine>
      </h2>

      {/* The position */}
      <div className="mt-20 md:mt-32 grid grid-cols-12 gap-6">
        <div className="col-span-12 md:col-span-10 md:col-start-3 lg:col-span-8 lg:col-start-4">
          <p
            data-testid="on-ai-statement"
            className="font-serif font-light tracking-tight leading-[1.05] text-[clamp(2.4rem,6.5vw,5.5rem)]"
          >
            <RevealLine delay={0.05}>{ON_AI.statement}</RevealLine>
            <RevealLine delay={0.22}>
              <span className="italic">{ON_AI.punch}</span>
            </RevealLine>
          </p>
          <motion.p
            data-testid="on-ai-closing"
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, delay: 0.45, ease: easeEditorial }}
            className="mt-12 font-sans text-[15px] md:text-base leading-relaxed text-neutral-400 max-w-[52ch]"
          >
            {ON_AI.closing}
          </motion.p>
        </div>
      </div>
    </section>
  );
}
